module.exports = __webpack_public_path__ + "img/xdgslg_float_ico_half.29323cf7.png";